import { reportAsyncError } from "@istari-frontend/shared";
import { useEffect, useRef } from "react";

type LookupFailure = { error: unknown; context: Record<string, string | null> };

export function collectLookupFailures(
  results: { status: string; error: unknown }[],
  context: (index: number) => LookupFailure["context"],
): LookupFailure[] {
  return results.flatMap((result, index) =>
    result.status === "error" ? [{ error: result.error, context: context(index) }] : [],
  );
}

export function useReportLookupFailures(label: string, failures: LookupFailure[]) {
  const reported = useRef(new Set<string>());
  useEffect(() => {
    failures.forEach(({ error, context }) => {
      const key = JSON.stringify([label, context]);
      if (reported.current.has(key)) return;
      reported.current.add(key);
      reportAsyncError(label, error, context);
    });
  }, [label, failures]);
}
